import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.08.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'
import {INTERACTION_LOCK} from 'powtoon-document/consts'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema, {strict: false})
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {strictMode, ignoreManifest, isValidTime, getMinTimeStep})

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content) {
  content.powtoon.slides.forEach(slide => {
    slide.tracks.forEach(track => {
      const isTrackLocked = track.noInteractive
      track.interactionLock = isTrackLocked ? INTERACTION_LOCK.REGULAR : INTERACTION_LOCK.NONE
      delete track.noInteractive
    })
  })
}
